/**
 * Configuración de EmailJS para el formulario de contacto
 */
export const EMAILJS = {
  SERVICE_ID: "service_ibm1a4j",
  TEMPLATE_ID: "template_s9fon5g",
  PUBLIC_KEY: "Xs_5gpoybEQ3MDsCi",
};
